function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.684 6H9.332V4.668c0-.688.059-1.121 1.043-1.121h1.246V1.426a17.773 17.773 0 00-1.824-.094c-1.809 0-3.129 1.105-3.129 3.133V6h-2v2.668l2-.004v6.004h2.664V8.664h2.047zm0 0",
  fill: "#FFF"
});

var SvgFacebook = function SvgFacebook(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTExLjY4NCA2SDkuMzMyVjQuNjY4YzAtLjY4OC4wNTktMS4xMjEgMS4wNDMtMS4xMjFoMS4yNDZWMS40MjZhMTcuNzczIDE3Ljc3MyAwIDAgMC0xLjgyNC0uMDk0Yy0xLjgwOSAwLTMuMTI5IDEuMTA1LTMuMTI5IDMuMTMzVjZoLTJ2Mi42NjhsMi0uMDA0djYuMDA0aDIuNjY0VjguNjY0aDIuMDQ3em0wIDAiIGZpbGw9IiNGRkYiLz48L3N2Zz4K";
export { SvgFacebook as ReactComponent };